export default __webpack_public_path__ + "static/media/gear-info.dbc2a6c3.svg";